import React from "react";

import { useDrawolaT } from "../../storage/i18n";
import { listProviders } from "../registry";

import type { AuthState, CloudProviderId } from "../types";

type Props = {
  providerId: CloudProviderId;
  setProviderId: (id: CloudProviderId) => void;
  displayName: string;
  authState: AuthState;
  onSignIn: () => void;
  onSignOut: () => void;
};

export const CloudAccountPanel: React.FC<Props> = ({
  providerId,
  setProviderId,
  displayName,
  authState,
  onSignIn,
  onSignOut,
}) => {
  const t = useDrawolaT();
  const providers = listProviders();

  return (
    <div className="drawOla-cloud-account">
      {providers.length > 1 && (
        <div className="drawOla-cloud-account__switcher">
          <label className="drawOla-cloud-account__switcher-label">
            {t("cloud.providerLabel")}
          </label>
          <select
            className="drawOla-cloud-account__switcher-select"
            value={providerId}
            onChange={(e) => setProviderId(e.target.value as CloudProviderId)}
          >
            {providers.map((id) => (
              <option key={id} value={id}>
                {id}
              </option>
            ))}
          </select>
        </div>
      )}

      {authState.status === "signed-out" && (
        <button
          type="button"
          className="drawOla-cloud-account__button drawOla-cloud-account__button--primary"
          onClick={onSignIn}
        >
          {t("cloud.signIn", { provider: displayName })}
        </button>
      )}

      {authState.status === "signing-in" && (
        <div className="drawOla-cloud-account__status">
          {t("cloud.signingIn")}
        </div>
      )}

      {authState.status === "signed-in" && (
        <div className="drawOla-cloud-account__info">
          <div className="drawOla-cloud-account__avatar" aria-hidden="true">
            {(authState.account.displayName ?? authState.account.email)
              .slice(0, 1)
              .toUpperCase()}
          </div>
          <div className="drawOla-cloud-account__meta">
            <div className="drawOla-cloud-account__email">
              {authState.account.email}
            </div>
            <div className="drawOla-cloud-account__subtext">
              {t("cloud.signedInAs", { provider: displayName })}
            </div>
          </div>
          <button
            type="button"
            className="drawOla-cloud-account__button drawOla-cloud-account__button--secondary"
            onClick={onSignOut}
          >
            {t("cloud.signOut")}
          </button>
        </div>
      )}

      {authState.status === "error" && (
        <div className="drawOla-cloud-account__error">
          {t("cloud.errorPrefix")} {authState.error}
        </div>
      )}
    </div>
  );
};
